/* eslint-disable */
import React, { FC } from 'react';
import { useObserver } from 'mobx-react-lite';
import {  FormState } from 'formstate';
import { useTranslation } from 'react-i18next';
import Form from 'react-bootstrap/Form';
import { PostalCodes } from '../../reference/components/PostalCodes';
import { YlInput } from './YlInput';
import { Cities } from '../../reference/components/Cities';
import { ComponentField } from '../dynamic-forms/ComponentField';
import { AddressRow } from '../../app/address/main-address/module-form/AddressRow';
import { Countries } from '../../reference/components/Countries';
import { States } from '../../reference/components/States';
import { Suburbs } from '../../reference/components/Suburbs';
import { CustomSuburb } from '../../reference/components/CustomSuburb';
import { getRootStore } from '../../app/root/RootStoreUtils';
import { getFormValues } from '@yl/react-forms';
import { enrollmentResource } from '../http/EnrollmentResource';

export enum AddressEntryType {
    MainAddress = "MainAddress",
    ShippingEntry = "ShippingEntry",
    BillingEntry = "BillingEntry"
}
interface YlAddressProps {
  row: AddressRow;
  index: number;
  form: FormState<any>;
  entryComponent: any;
  entryType: AddressEntryType;
  countryIso: string;
}

export const YlAddress: FC<YlAddressProps> = ({
    row,
    index,
    form,
    entryComponent,
    entryType,
    countryIso
}) => {
  const { t } = useTranslation();

  function getCustomerAttributes(field: ComponentField) {
    const attr = {} as any;
    if (field.maxLength) {
      attr.maxLength = field.maxLength;
    }
    

    if (field.minLength) {
      attr.minLength = field.minLength;
    }

    return attr;
  }

  async function tryAutoFillData(field: ComponentField) {
    const country = getRootStore(entryComponent).enrollmentStatus.countryIso;
    const self = entryComponent;
    const postalCodeFieldValue = self.reactForm.$[field.name].value;
    //if(country === 'ID') {
    //  await tryAutoFillIdFormData(field, entryComponent, postalCodeFieldValue);
    //}
    switch (country){
      case 'ID': await tryAutoFillCountryFormData(field, entryComponent, postalCodeFieldValue , 'ID' , 5); break;
      case 'JP': await tryAutoFillJpFormData(field, entryComponent, postalCodeFieldValue); break;
      case 'MX': await tryAutoFillMxFormData(field, entryComponent, postalCodeFieldValue); break;
      case 'MY': await tryAutoFillCountryFormData(field, entryComponent, postalCodeFieldValue, 'MY' , 5); break;
      default: break;
    }
  }
  async function tryAutoFillJpFormData(field: ComponentField, self: any, postalCode: string): Promise<void> {
    if (field.name === 'postalCode' && postalCode.length >= 7 && postalCode.length <= 8 && postalCode !== self.lastPostalCode) {
      self.setPostalCode(postalCode);
      let data = getFormValues(self.reactForm);
      const response = await enrollmentResource.get<any>(`/zip-to-address-japan/${postalCode}`);
      data.postalCode = postalCode;

      data.jpZipNotFound = !response.data.found;

      if (response.data.city) {
        data.city = response.data.city;
      }
      if (response.data.prefecture) {
        const states = getRootStore(self).reference.getStatesForCountry("JP");
        const responseStateInUpperCase = response.data.prefecture.toUpperCase();
        let state = states?.find(s => s.name.toUpperCase() == responseStateInUpperCase);

        if (!state){
          state = states?.find(s => responseStateInUpperCase.includes(s.name.toUpperCase()) ||
              s.name.toUpperCase().includes(responseStateInUpperCase));
        }

        if (state) {
          data.stateProv = state.abbreviation;
        }
      }
      if (response.data.street1) {
        data.street1 = response.data.street1;
      }

      self.updateFromForm(data);
    }

  }

  async function tryAutoFillCountryFormData(field: ComponentField, self: any, postalCode: string , country: string , postalCodeLength : number): Promise<void> {
    if (field.name === 'postalCode' && postalCode.length === postalCodeLength && postalCode !== self.lastPostalCode) {
      self.setPostalCode(postalCode);
      let data = getFormValues(self.reactForm);

      const [cityResponse, stateResponse] = await Promise.all([
        enrollmentResource.get<any>(`/countries/${country}/postalCodes/${postalCode}/cities`),
        enrollmentResource.get<any>(`/countries/${country}/postalCodes/${postalCode}/states`)
      ]);

      data.postalCode = postalCode;
      if (cityResponse.data.length) {
        data.city = cityResponse.data[0].name;
      }

      if (cityResponse.data.length && country === 'MY') {
        const cities = await getRootStore(self).reference.getCitiesByPostalCodeAndCountry(postalCode, country);
        let city = cities?.find(c => c.name.toUpperCase() === cityResponse.data[0].name.toUpperCase());
        
        if (city) {
          data.city = city.name;
        }
      }
      if (stateResponse.data.length) {
        const stateName = stateResponse.data[0].name;
        const states = getRootStore(self).reference.getStatesForCountry(country);
        const responseStateInUpperCase = stateName.toUpperCase();
        let state = states?.find(s => s.name.toUpperCase() == responseStateInUpperCase);

        if (!state) {
          state = states?.find(s => responseStateInUpperCase.includes(s.name.toUpperCase()) ||
            s.name.toUpperCase().includes(responseStateInUpperCase));
        }

        if (state) {
          data.stateProv = state.abbreviation;
        }
      }

      self.updateFromForm(data);
    }

  }
  async function tryAutoFillMxFormData(field: ComponentField, self: any, postalCode: string): Promise<void> {
    if (field.name === 'postalCode' && postalCode.length === 5 && postalCode !== self.lastPostalCode) {
      self.setPostalCode(postalCode);
      let data = getFormValues(self.reactForm);
      
      const response = await enrollmentResource.get<any>(`/latam-address/MEX/${postalCode}`);
      data.postalCode = postalCode;

      if (response.data.city) {
        data.city = response.data.city;
      }
      if (response.data.state) {
        const states = getRootStore(self).reference.getStatesForCountry("MX");
        const responseStateInUpperCase = response.data.state.toUpperCase();
        let state = states?.find(s => s.name.toUpperCase() == responseStateInUpperCase);

        if (!state){
          state = states?.find(s => responseStateInUpperCase.includes(s.name.toUpperCase()) ||
              s.name.toUpperCase().includes(responseStateInUpperCase));
        }

        if (state) {
          data.stateProv = state.abbreviation;
        }
      }
      if (response.data.municipality) {
        data.neighborhood = response.data.municipality;
      }
      self.updateFromForm(data);
      self.disableFormFieldsIfNeeded(response.data);
      self.updatePostalCodeValidationMessage(response.data);
    }

  };

  return useObserver(() => {
    return (
        
        <Form.Row key={index}>
        {row.formFields.map((field: ComponentField) => (
          <React.Fragment key={field.name}>
              {field.name === 'postalCode' && !field.disabled && (
                <>
                  <PostalCodes
                    required={field.required}
                    size={field.size}
                    field={form.$[field.name]}
                    customAttributes={getCustomerAttributes(field)}
                    label={field.labelKey}
                    additionalError={entryComponent.invalidPostalCodeMessage}
                    id={field.name}
                    disabled={field.disabled}
                    fieldType={field.fieldType}
                    countryIso={countryIso}
                    stateProv={entryComponent.targetStateProv}
                    city={entryComponent.targetCity}
                    onChange={() => {
                      tryAutoFillData(field);
                      entryComponent.applyFormat(field);
                  }}
                />
                {entryType == AddressEntryType.MainAddress && 
                  entryComponent.jpZipNotFound && <p>{t('ZipCodeNotFoundNotification')}</p>}
              </>

            )}

            {field.fieldType === 'Input' &&
              field.name !== 'postalCode' &&
              field.name !== 'city' &&
              field.name !== 'phoneNumber' &&
              (field.name !== 'street2' || countryIso !== 'CA') && (
                <YlInput
                  required={field.required}
                  size={field.size}
                  field={form.$[field.name]}
                  customAttributes={getCustomerAttributes(field)}
                  label={field.labelKey}
                  redLabel={field.redLabelKey}
                  additionalLabel={field.additionalLabel}
                  id={field.name}
                  disabled={field.disabled}
                  onChange={() => entryComponent.applyFormat(field)}
                />
              )}
            {field.name === 'city' && (
              <Cities
                id={field.name}
                fieldType={field.fieldType}
                countryIso={countryIso}
                stateProv={entryComponent.targetStateProv}
                required={field.required}
                name={form.$.city.value}
                field={form.$[field.name]}
                size={field.size}
                label={field.labelKey}
                disabled={field.disabled}
                onChange={city => {
                    if(entryType == AddressEntryType.MainAddress || entryType == AddressEntryType.BillingEntry){
                        entryComponent.setCity(city);
                    }
                }}
              />
            )}
            
            {field.fieldType === 'Select' && field.name === 'country' && (
              <Countries
                size={field.size}
                required={field.required}
                field={form.$[field.name]}
                form={form}
                disabled={field.disabled}
                label={field.labelKey}
                onChange={country => {
                    if(entryType == AddressEntryType.MainAddress){
                        entryComponent.warnAboutMarketChange(country);
                    }
                    else {
                        entryComponent.onCountryChange(country);
                    }
                }}
              />
            )}

            {field.fieldType === 'Select' && field.name === 'stateProv' && (
              <States
                required={field.required}
                countryIso={form.$.country.value}
                field={form.$[field.name]}
                size={field.size}
                label={field.labelKey}
                disabled={field.disabled}
                onChange={stateProv => {
                    switch(entryType){
                        case AddressEntryType.MainAddress: 
                        case AddressEntryType.BillingEntry:
                            entryComponent.setStateProv(stateProv);
                      case AddressEntryType.ShippingEntry:
                            entryComponent.setStateProv(stateProv);
                            entryComponent.onStateChange;
                        default:
                            return;
                    }
                }}
              />
            )}

            {field.fieldType === 'Select' && field.name === 'suburb' && (
              <Suburbs
                required={field.required}
                stateAbbreviation={form.$.stateProv.value}
                noSuburb={form.$.noSuburb.value}
                field={form.$[field.name]}
                size={field.size}
                label={field.labelKey}
                onChange={entryComponent.UpdateSuburb}
              />
            )}

            {field.fieldType === 'Check' && field.name === 'noSuburb' && (
              <CustomSuburb
                field={form.$.noSuburb}
                label={field.labelKey}
                id={field.name}
                onChange={entryComponent.UpdateNoSuburb}
              />
            )}
            {(getRootStore(entryComponent).enrollmentStatus.countryIso == 'HK' || getRootStore(entryComponent).enrollmentStatus.countryIso == 'MO') && 
            field.name == 'phoneNumber' &&
            entryType == AddressEntryType.ShippingEntry &&(
                      <YlInput
                        required={field.required}
                        size={field.size}
                        field={entryComponent.reactForm.$[field.name]}
                        customAttributes={getCustomerAttributes(field)}
                        label={field.labelKey}
                        id={field.name}
                        disabled={field.disabled}
                        onChange={() => entryComponent.applyFormat(field)}
                        onBlur={entryComponent.onInputBlurred}
                      />
              )}

            {( getRootStore(entryComponent).enrollmentStatus.countryIso == 'MY') &&
              field.name == 'phoneNumber' &&
              (entryType == AddressEntryType.BillingEntry || entryType == AddressEntryType.ShippingEntry)  && (
                <YlInput
                  required={field.required}
                  size={field.size}
                  field={entryComponent.reactForm.$[field.name]}
                  customAttributes={getCustomerAttributes(field)}
                  label={field.labelKey}
                  id={field.name}
                  disabled={field.disabled}
                  onChange={() => entryComponent.applyFormat(field)}
                  onBlur={entryComponent.onInputBlurred}
                />
              )}

          </React.Fragment>
        ))}
      </Form.Row>
    )
  })
}
